import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import CardTypeButton from 'containers/CreateSurveyModal/CardTypeButton';
import classNames from 'classnames';

import QuestionHeader from '../QuestionHeader';

const CardType = ({ question, onUpdateVariable, skipTopMargin }) => {
  const { value, options } = question;

  const onChange = useCallback(
    (newValue) => {
      onUpdateVariable(newValue);
    },
    [onUpdateVariable],
  );

  return (
    <React.Fragment>
      <QuestionHeader
        title={question.body}
        note={question.note}
        skipTopMargin={skipTopMargin}
      />
      <div>
        {options.map((option, optionIndex) => (
          <CardTypeButton
            key={option.value}
            title={option.title}
            description={option.body}
            onClick={() => onChange(option.value)}
            className={classNames({
              'margin-top-lg': optionIndex > 0,
            })}
            selected={option.value === value}
            titleClassName="text-size-h3 color-grey-10 text-weight-bold margin-btm-xxs"
            descriptionClassName="text-size-secondary color-grey-9"
          />
        ))}
      </div>
    </React.Fragment>
  );
};

CardType.propTypes = {
  question: PropTypes.object,
  onUpdateVariable: PropTypes.func.isRequired,
  skipTopMargin: PropTypes.bool,
};

export default CardType;
